import { useEffect, useRef, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import { Spinner } from 'common/components/loader/Spinner';

const IdpInitiatedLogin = () => {
  const { loginWithRedirect } = useAuth0();
  const started = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (started.current) return;

    started.current = true;
    loginWithRedirect().catch(() => setError(true));
  }, [loginWithRedirect]);

  if (error) {
    return (
      <p role="alert">
        Unable to start single sign-on. Please return to your identity provider and try again.
      </p>
    );
  }

  return <Spinner />;
};

export default IdpInitiatedLogin;
